import $ from 'jquery';

class JobPostingsStateManager {
  constructor() {
    this.state = {
      isInitial: true,
      $jobPostings: $(),
      $listAppend: $(),
      $form: $(),
      location: '',
      activeFiltersCount: 0,
      href: '',
      totalItemsCount: 0,
      isAppendMode: false,
      $firstNewJobPosting: $(),
    };

    this.subscribers = [];
  }

  init(data) {
    this.state = {
      ...this.state,
      ...data,
    };
    this.persistState();
  }

  /*
   * Update state methods
   */
  update(data) {
    this.state = {
      ...this.state,
      ...data,
      isAppendMode: false,
      isInitial: false,
    };

    this.notifySubscribers();
    this.persistState();
  }

  addJobPostings(data) {
    const $newJobPostings = data.$jobPostings;
    this.state = {
      ...this.state,
      ...data,
      $jobPostings: this.state.$jobPostings.add($newJobPostings), // Extend
      isAppendMode: true,
      $firstNewJobPosting: $newJobPostings.eq(0),
      isInitial: false,
    };
    this.notifySubscribers();
    this.persistState();
  }

  /*
   * Serialization API
   */
  toSerialized() {
    return serializeState(this.state);
  }

  restoreFromSerialized(serialized) {
    this.state = deserializeState(serialized);
    this.notifySubscribers();
    this.persistState();
  }

  /*
   * Event-Handling
   */
  subscribe(callback) {
    this.subscribers.push(callback);

    return () => {
      this.subscribers = this.subscribers.filter(cb => cb !== callback);
    };
  }

  notifySubscribers() {
    this.subscribers.forEach(callback => callback(this.state));
  }

  /*
   * Persistence
   */
  persistState() {
    try {
      sessionStorage.setItem(
        'jobPostingsState',
        JSON.stringify(serializeState(this.state))
      );
    } catch (e) {
      console.error('Failed to persist state:', e);
    }
  }

  restoreState() {
    const savedState = sessionStorage.getItem('jobPostingsState');

    if (!savedState) return false;

    try {
      // Parse saved state
      const parsedState = JSON.parse(savedState);

      // Only restore state if we're on the same page
      if (parsedState.href !== window.location.href) {
        return false;
      }

      this.state = deserializeState(parsedState);
      this.notifySubscribers();
      return true;
    } catch (e) {
      console.error('Failed to restore state:', e);
      return false;
    }
  }
}

const JobPostingState = new JobPostingsStateManager()

// Singleton
export default JobPostingState;


/**
 * Helper function to serialize state with jQuery objects
 * Automatically converts all jQuery objects (properties starting with $)
 * to HTML string arrays for JSON storage
 */
function serializeState(state) {
  // Create a copy of the state
  const serializedState = {...state};

  // Identify and convert all jQuery properties (starting with $)
  Object.keys(serializedState).forEach(key => {
    if (key.startsWith('$')) {
      const $elements = serializedState[key];
      // Convert jQuery to HTML strings or set empty if not available
      serializedState[key] = $elements && $elements.length
        ? $elements.map(function() { return $(this).prop('outerHTML'); }).get()
        : [];
    }
  });

  return serializedState;
}

/**
 * Helper function to deserialize state
 * Converts HTML string arrays back to jQuery objects for all $ properties
 */
function deserializeState(state) {
  Object.keys(state).forEach(key => {
    if (key.startsWith('$')) {
      const htmlArray = state[key];
      // Only convert array values (HTML string arrays)
      if (Array.isArray(htmlArray)) {
        // Convert HTML strings back to jQuery objects
        state[key] = htmlArray.length ? $(htmlArray.join('')) : $();
      }
    }
  });

  return state;
}
